import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './firestore'
import { ThemeProvider } from 'styled-components';
import Theme from './Themes/Theme';
import GlobalStyle from './Themes/GlobalStyle';
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);



root.render(


  <React.StrictMode>
    <ThemeProvider theme= {Theme}>
      <GlobalStyle/>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
